<template>
  <div v-if="!!route && !route.germanDeparture">
    <template v-if="hasCheckInTimes">
      <div class="row d-flex align-items-baseline mb-3">
        <div class="col-3">
          <div class="row flex-column">
            <div class="col d-flex justify-content-center">
              <div class="circle rounded-circle bg-expinet-blue color-sachlich-white d-flex justify-content-center align-items-center">
                {{ checkInTimesStart }}
              </div>
            </div>
            <div 
              v-if="isDifferentDepartureDay" 
              class="col d-flex justify-content-center pt-1"
            >
              {{ cruise!.startDate }}
            </div>
            <div class="col d-flex justify-content-center p-0 text-center">
              Beginn des Check-in
            </div>
          </div>
        </div>
        <div class="col-3 line-grey" />
        <div class="col-2">
          <div class="row flex-column">
            <div class="col d-flex justify-content-center">
              <div class="circle rounded-circle bg-aida-red color-sachlich-white d-flex justify-content-center align-items-center">
                {{ checkInTimesEnd }}
              </div>
            </div>
            <div 
              v-if="isDifferentDepartureDay" 
              class="col d-flex justify-content-center pt-1"
            >
              {{ cruise!.startDate }}
            </div>
            <div class="col d-flex justify-content-center p-0 text-center">
              Ende des Check-in
            </div>
          </div>
        </div>
        <div class="col line-grey" />
        <div class="col-2">
          <div class="row flex-column">
            <div class="col d-flex justify-content-center">
              <div class="circle rounded-circle bg-expinet-blue color-sachlich-white d-flex justify-content-center align-items-center">
                {{ departureSegment?.departureTime ?? '' }}
              </div>
            </div>
            <div 
              v-if="isDifferentDepartureDay" 
              class="col d-flex justify-content-center pt-1"
            >
              {{ departureSegment?.day ?? '' }}
            </div>
            <div class="col d-flex justify-content-center p-0 text-center">
              Abfahrt
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="lh-base ps-3">
      <ul v-if="hasCheckInTimes">
        <li>
          Der Check-in für individuell anreisende Gäste findet in der Zeit von
          {{ checkInTimesStart }} bis {{ checkInTimesEnd }} Uhr statt.
        </li>
        <li>
          Da ein späterer Check-in nicht mehr möglich ist, sollte bitte unbedingt ausreichend Zeit für die Anreise
          eingeplant werden.
        </li>
        <li>Transferleistungen vom Flughafen zum Hafen sind nicht inkludiert.</li>
        <li>
          Unser Tipp: In ausgewählten Häfen kann auf Wunsch ein früherer Check-in bis 3 Tage vor Reisebeginn
          kostenpflichtig auf myAIDA reserviert werden (nach Verfügbarkeit).
        </li>
        <li>
          Suiten-Gäste, Vielfahrer der Clubstufen Kiss und Smile sowie Gäste, die sich für den Tarif COMFORT ALL IN entschieden haben, 
          können den „Früher an Bord“ Check-in kostenfrei auf myAIDA reservieren (nach Verfügbarkeit).
        </li>
      </ul>
      <ul v-else>
        <li>Individuell anreisende Gäste checken zu einer vorgegebenen Zeit ein, vorwiegend am Nachmittag.</li>
        <li>
          Das konkrete Anreisezeitfenster sowie die Möglichkeit das Anreiseprodukt "Früher an Bord" Check-in hinzuzufügen, 
          teilen wir auf myAIDA (mind. ein Jahr vor Reisebeginn) sowie im AIDA Ticket mit.
        </li>
        <li>Das Ticket versenden wir nach Zahlungseingang und ab ca. 3 Wochen vor Reisebeginn.</li>
      </ul>
    </div>
  </div>

  <div v-else>
    <div class="lh-base ps-3">
      <ul>
        <li>
          Ein Anreisezeitfenster wählen Ihre Kunden verpflichtend bis 3 Tage vor Reisebeginn auf myAIDA unter
          „Schiffsmanifest“.
        </li>
        <li v-if="hasCheckInTimes">
          Der Check-in ist bis spätestens {{ checkInTimesEnd }} Uhr möglich.
        </li>
        <li>
          Unser Tipp: In ausgewählten Häfen kann auf Wunsch ein früherer Check-in bis 3 Tage vor Reisebeginn
          kostenpflichtig auf myAIDA reserviert werden (nach Verfügbarkeit).
        </li>
        <li>
          Suiten-Gäste, Vielfahrer der Clubstufen Kiss und Smile sowie Gäste, die sich für den Tarif COMFORT ALL IN
          entschieden haben, können den „Früher an Bord“ Check-in kostenfrei auf myAIDA reservieren (nach
          Verfügbarkeit).
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { useCruiseStore } from '@/store';
import { IDetailPortInformation } from '@gecko-akh/pkg-cruise-api-types/src/vivien/pdf_offer';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  computed: {
    ...mapState(useCruiseStore, {
      cruise: store => store.cruise,
      route: store => store.route,
    }),
    isDifferentDepartureDay() {
      return !!this.cruise && !!this.departureSegment && this.cruise.startDate !== this.departureSegment.day
    },
    departureSegment() {
      // in case the cruise departs one or more days later than the given check in
      const segments = this.route?.segments as IDetailPortInformation[]

      return segments.find(segment => !!segment.departureTime)
    },
    hasCheckInTimes() {
      return !!this.cruise?.checkInTimes
    },
    checkInTimesStart() {
      return this.cruise?.checkInTimes?.start ?? ''
    },
    checkInTimesEnd() {
      return this.cruise?.checkInTimes?.end ?? ''
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.circle {
  width: 50px;
  height: 50px;
}

.line-grey {
  height: 1px;
  background-color: $color-expinet-gray;
}
</style>
